const skus = skusString.split(',').map(sku => sku.trim());
const publicToken = "5cc84568c8222576036a279409b2c2b9";
const getProductData = sku => `{
    products(first: 10, query: "${sku}") {
        nodes {
            title
            id
            images(first: 1) {
                nodes {
                    url(transform: {maxHeight: 260, maxWidth: 260})
                }
            }
            variants(first: 2) {
                nodes {
                    sku
                    id
                }
            }
            priceRange {
                minVariantPrice {
                    amount
                    currencyCode
                }
                maxVariantPrice {
                    amount
                    currencyCode
                }
            }
            totalInventory
            onlineStoreUrl
            unitOfMeasure: metafield(namespace: "product", key: "unit_of_measure") {
                value
            }
            availability: metafield(namespace: "product", key: "availability") {
                value
            }
            nonStockStatus: metafield(namespace: "product", key: "non_stock_status") {
                value
            }
            mapPricing: metafield(namespace: "product", key: "map_pricing") {
                value
            }
            saleDefaultPrice: metafield(namespace: "product", key: "sale_item_default_price") {
                value
            }
            condition: metafield(namespace: "product", key: "condition") {
                value
            }
            advanced_plp_link: metafield(namespace: "product", key: "advanced_plp_link") {
                value
            }
            pricingNote: metafield(namespace: "product", key: "cart_notes_2") {
                value
            }
            catalogFilter: metafield(namespace: "product", key: "cat_filter") {
                value
            }
        }
    }
}`;

const renderRelatedProducts = (data, sku, createSlider) => {
let product = data.data.products.nodes[0];
if (data.data.products.nodes.length > 1) {
    product = data.data.products.nodes.find(node => node.variants.nodes[0].sku === sku);
}
const section = document.querySelector('.related-products');
const carousel = section.querySelector('.carousel');
    if (product) {
        let buttonText;
        let requestQuote = false;
        let hasMultipleVariants = false;
        const availability = product.availability ? product.availability.value.toLowerCase() : '';
        const advancedProductListingsLink = product.advanced_plp_link ? product.advanced_plp_link.value : '';
        const mapPricingHit = product.pricingNote && product.pricingNote.value === 'Items with MAP pricing';
        const variants = product.variants ? product.variants.nodes : [];
        const variantId = product.variants ? product.variants.nodes[0].id.replace('gid://shopify/ProductVariant/', '') : '';
        const getBadge = () => {
          const categoryBadge = product.catalogFilter ? product.catalogFilter.value : '';
          return categoryBadge === 'New Products' ? 'New' : ['Sale', 'Used'].includes(categoryBadge) ? categoryBadge : '';
        };
        const badge = getBadge();
        const badgeHandle = badge.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        const totalInventory = product.totalInventory ? product.totalInventory : 0;
        const saleDefaultPrice = product.saleDefaultPrice ? product.saleDefaultPrice.value : '';

        if (variants.length >= 2 || advancedProductListingsLink) {
            buttonText = 'Choose Options';
            hasMultipleVariants = true;
        } else if (availability === 'pre-order' || availability === 'pre-order-only') {
            buttonText = 'Preorder';
        } else if (availability === 'call for pricing') {
            buttonText = 'Request a Quote';
            requestQuote = true;
        } else if (advancedProductListingsLink) {
            buttonText = 'Choose Options';
        } else {
            buttonText = 'Add to Cart';
        }

        const relatedProductsCard = document.createElement('li');
        relatedProductsCard.classList.add('related-products-card');
        relatedProductsCard.classList.add('item');
        relatedProductsCard.classList.add('twcss-p-2');
        relatedProductsCard.setAttribute('data-sku', sku);
        relatedProductsCard.innerHTML = `
        <div class="related-products-card-item card-wrapper product-card-wrapper underline-links-hover twcss-shadow-solid twcss-rounded-2xl twcss-border-black twcss-min-h-[27.8125rem] twcss-p-2 twcss-flex twcss-flex-col twcss-justify-between">
            ${badge ? `<div class="badge badge--${badgeHandle}">${badge}</div>` : ''}
            ${saleDefaultPrice ? `<div class="badge badge--sale">Sale</div>` : ''}
            <a href="${advancedProductListingsLink ? advancedProductListingsLink : product.onlineStoreUrl}" class="related-products-card-link" aria-label="${product.title}">
            <div class="custom-product-card">
                <div class="custom-product-card-image">
                    <img src="${product.images.nodes[0].url}" alt="${product.title}" width="250" height="250" class="custom-product-card-image-img">
                </div>
            </div>
            <div class="custom-product-card-content twcss-text-left">
                <h3 class="custom-product-card-title twcss-text-left twcss-font-normal twcss-text-[18px] twcss-leading-[23px] twcss-text-[#19242e]">${product.title}</h3>
                <span class="custom-product-card-sku twcss-text-left twcss-block"><strong>SKU:</strong> ${product.variants.nodes[0].sku}</span>
                ${!advancedProductListingsLink ? `
                <div class="inventory-wrapper twcss-text-left">
                    ${product.nonStockStatus ? `
                    <p class="non-stock-status twcss-text-left">${product.nonStockStatus.value}</p>
                    ` : totalInventory > 0 ? `
                    <p class="in-stock twcss-text-left">
                        <span class="twcss-text-green">In stock </span>(${totalInventory >= 99 ? `<span class="twcss-text-green high-stock">99+ Available</span>` : totalInventory > 5 ? `<span class="twcss-text-green has-stock">${totalInventory} Available</span>` : totalInventory >= 1 ? `<span class="twcss-text-red low-stock">${totalInventory} left!</span>` : ''})
                    </p>
                    ` : `
                    <p class="not-tracked twcss-text-left">${availability ? 'Available on Backorder' : ''}</p>
                    `}
                </div>
                ` : ``}

                <div class="custom-product-card-price twcss-text-left">
                ${!advancedProductListingsLink && !mapPricingHit && availability !== 'call for pricing' ? `
                    ${product.priceRange.minVariantPrice.amount === product.priceRange.maxVariantPrice.amount ? `
                        <span class="custom-product-card-price-value twcss-text-left
                        
                        ">${product.priceRange.minVariantPrice.currencyCode === 'USD' ? '$' : product.priceRange.minVariantPrice.currencyCode}${parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2)}</span><span class="custom-product-card-price-unit twcss-font-normal twcss-text-left">${product.unitOfMeasure ? '/ ' + product.unitOfMeasure.value : ''}</span>
                    ` : ''}

                ${product.saleDefaultPrice && parseFloat(product.saleDefaultPrice.value) > parseFloat(product.priceRange.minVariantPrice.amount) && Math.round((parseFloat(product.saleDefaultPrice.value) - parseFloat(product.priceRange.minVariantPrice.amount)) / parseFloat(product.saleDefaultPrice.value) * 100) > 1 ? `
                    <span class="custom-product-card-price-value twcss-text-left twcss-line-through !twcss-font-normal custom-product-card-price-value-sale">${product.priceRange.minVariantPrice.currencyCode === 'USD' ? '$' : product.priceRange.minVariantPrice.currencyCode}${parseFloat(product.saleDefaultPrice.value).toFixed(2)}</span>
                    <span class="custom-product-card-price-percentage twcss-text-left !twcss-font-normal">${Math.round((parseFloat(product.saleDefaultPrice.value) - parseFloat(product.priceRange.minVariantPrice.amount)) / parseFloat(product.saleDefaultPrice.value) * 100)}% off</span>
                ` : ''}
                ` : advancedProductListingsLink ? `<p class="price-message twcss-font-normal">${(window.algoliaStrings && window.algoliaStrings.priceVaries) || 'Price varies'}</p>` : mapPricingHit ? `<p class="price-message price-message-map-pricing twcss-font-bold">${(window.algoliaStrings && window.algoliaStrings.mapPricing) || 'Price will appear in cart at checkout'}</p>` : '' }
                </div>
            </div>
            </a>

            ${!requestQuote && !hasMultipleVariants && !advancedProductListingsLink ? `
                <form 
                id="algolia-add-to-cart-${variantId}" 
                action="/cart/add" 
                method="post"
                enctype="multipart/form-data" 
                class="mobile-form"
                >
                <div class="form-wrapper" style="display: flex; align-items: center; gap: 8px;">
                    <input 
                    type="number" 
                    name="quantity" 
                    value="1" 
                    min="1"
                    class="quantity-input qty"
                    style="width: 60px; height: 35px; padding: 0px 8px; border: 1px solid rgb(221, 221, 221); border-radius: 4px; border-color: #19242e; color: #19242e; text-align: center;"
                    />
                    <input type="hidden" name="id" value="${variantId}" />
                    <button class="ais-hit--cart-button quick-add__submit button button--full-width button--secondary twcss-inline twcss-bg-accentBlue twcss-min-h-[1rem] twcss-all-w-reset twcss-min-w-40 twcss-text-white twcss-p-2 twcss-border-reset" data-form-id="algolia-add-to-cart-${variantId}">
                    <span>${buttonText}</span>
                    </button>
                </div>
                </form>
            ` : hasMultipleVariants && !advancedProductListingsLink ? `
                <a 
                href="${product.onlineStoreUrl}" 
                class="ais-hit--cart-button request-a-quote request-a-quote-mobile"
                >
                <span>${buttonText}</span>
                </a>
            ` : advancedProductListingsLink ? `
                <a 
                href="${advancedProductListingsLink}" 
                class="ais-hit--cart-button request-a-quote request-a-quote-mobile"
                >
                <span>${buttonText}</span>
                </a>
                ` : `
                <a 
                href="${product.onlineStoreUrl}" 
                class="ais-hit--cart-button request-a-quote request-a-quote-mobile"
                >
                <span>${buttonText}</span>
                </a>
            `}
        </div>
        `;
        carousel.appendChild(relatedProductsCard);
        if (createSlider) {
            generateSlider(carousel, skus);
        }
    } else {
        if (createSlider) {
            generateSlider(carousel, skus);
        }
    }
};

const sortCarouselBySkuOrder = (carousel, skus, callback) => {
    if (!carousel || !skus || !Array.isArray(skus)) {
        console.warn('sortCarouselBySkuOrder: Invalid parameters provided');
        return [];
    }

    // Only keep items whose data-sku is in skus
    const items = Array.from(carousel.children).filter(item => skus.includes(item.getAttribute('data-sku')));

    items.sort((a, b) => {
        const skuA = a.getAttribute('data-sku');
        const skuB = b.getAttribute('data-sku');
        return skus.indexOf(skuA) - skus.indexOf(skuB);
    });
    // Re-append only the filtered and sorted items
    items.forEach(item => carousel.appendChild(item));

    if (typeof callback === 'function') {
        callback(items, carousel, skus);
    }
};

const generateSlider = (carousel, skus) => {
    setTimeout(() => {
        sortCarouselBySkuOrder(carousel, skus, (sortedItems) => {
            while (carousel.firstChild) {
                carousel.removeChild(carousel.firstChild);
            }

            sortedItems.forEach(item => {
                carousel.appendChild(item);
            });

            new Glider(carousel, {
                slidesToShow: 1.2,
                slidesToScroll: 1,
                scrollLock: true,
                scrollLockDelay: 0,
                duration: 0.25,
                arrows: {
                    prev: '.control__prev',
                    next: '.control__next'
                },
                responsive: [
                    {
                        breakpoint: 1325,
                        settings: {
                            slidesToShow: 5.32,
                            slidesToScroll: 5,
                            duration: 1,
                        }
                    },
                    {
                        breakpoint: 1115,
                        settings: {
                            slidesToShow: 4.35,
                            slidesToScroll: 4,
                            duration: 1,
                        }
                    },
                    {
                        breakpoint: 875,
                        settings: {
                            slidesToShow: 3.33,
                            slidesToScroll: 3,
                            duration: 1,
                        }
                    },
                    {
                        breakpoint: 550,
                        settings: {
                            slidesToShow: 2.23,
                            slidesToScroll: 2,
                            duration: 1,
                        }
                    }
                ]
            });

            const loadingCarousel = document.querySelector('.loading-carousel');
            if (loadingCarousel) {
                loadingCarousel.classList.remove('loading-carousel');
                if (!carousel.querySelector('.related-products-card-item')) {
                    const relatedProductsSection = document.querySelector('.more-items-to-consider');
                    if (relatedProductsSection) {
                        relatedProductsSection.remove();
                    }
                }
            }
        });
    }, 1500);
};

for (const sku of skus) {
    let createSlider = false;
    if (sku === skus[skus.length - 1]) {
        createSlider = true;
    }
    fetch(`https://gessweinco.myshopify.com/api/graphql`, {
        method: "post",
        headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": publicToken
        },
        body: getProductData(sku)
    })
        .then(res => res.json())
        .then(data => renderRelatedProducts(data, sku, createSlider, skus));
}
